class AppError implements Error {
  public name = "AppError";
  public message = "AppError";
}

export class NoVideoInputDevicesError extends AppError {
  public name = "NoVideoInputDevicesError";
  public message = "AppError";
}
